/**
 * Directive used my micro front-ends to hel highlight items
 * when some of micro front-end (also called fragment) internal state is active.
 * Example: /application/tenant/dashboard is a internal fragment state of blip-tenant application,
 * so the current active state is "dashboard". Remember that all fragments define a "path" variable to generalize
 * fragment routes.
 *
 * Usage: in the element that will be highlighted, add this directive
 * and pass a key/value object with class/state. Example:
 * <li fragment-active="{'active-link': 'dashboard'}">Active state</li>
 */
export class FragmentActiveDirective {
    static $inject = ['$stateParams', '$rootScope'];
    constructor($stateParams, $rootScope) {
        'ngInject';
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.restrict = 'A';
        this.classes = [];
    }
    link(scope, element, attrs) {
        const initializeListener = () => {
            try {
                this.removeClasses(element[0]);
                const activeExpression = JSON.parse(attrs.fragmentActive.replaceAll("'", '"'));
                for (const prop in activeExpression) {
                    if (this.$stateParams &&
                        this.$stateParams.path &&
                        this.$stateParams.path === activeExpression[prop] &&
                        element[0]) {
                        this.addClassToElement(prop, element[0]);
                    }
                }
                scope.$on('$destroy', () => {
                    this.removeClasses(element[0]);
                });
            }
            catch (e) {
                throw e;
            }
        };
        this.$rootScope.$on('$stateChangeSuccess', initializeListener);
        scope.$on('$destroy', () => this.removeClasses(element[0]));
        initializeListener();
    }
    addClassToElement(className, element) {
        element.classList.add(className);
        this.classes = this.classes.concat(className);
    }
    removeClasses(element) {
        this.classes.map(c => {
            element.classList.remove(c);
        });
    }
    static factory($stateParams, $rootScope) {
        return new FragmentActiveDirective($stateParams, $rootScope);
    }
}
FragmentActiveDirective.$inject = ['$stateParams', '$rootScope'];
